module.exports = __webpack_public_path__ + "static/media/signup_bg.a557ec48.jpg";